export class DetailTaskTableOptions {
    allowLocking: boolean;
    showAnimals: boolean;
    showSamples: boolean;
}
